import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { BrandLogo } from '@examflow/ui';
import { useAuth } from '../features/auth/AuthContext';

const ForgotPasswordPage: React.FC = () => {
  const { signIn, isAuthenticated, loading } = useAuth();
  const [starting, setStarting] = useState(false);

  if (!loading && isAuthenticated) {
    return <Navigate to="/workspace" replace />;
  }

  const handleContinue = () => {
    setStarting(true);
    // Password reset is completed on Casdoor's hosted experience
    signIn('/workspace', 'signIn');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="mb-8 text-center">
          <div className="mb-4 flex justify-center">
            <BrandLogo variant="full" size={28} />
          </div>
          <h1 className="text-xl font-semibold text-slate-900">忘记密码</h1>
          <p className="mt-2 text-sm text-slate-500">
            密码重置在登录页完成。进入后选择「忘记密码」并按提示操作。
          </p>
        </div>

        <button
          type="button"
          onClick={handleContinue}
          disabled={loading || starting}
          className="flex w-full items-center justify-center rounded-lg bg-[#1f4fd8] px-4 py-2.5 text-sm font-medium text-white transition hover:bg-[#1a43b8] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading || starting ? '正在跳转…' : '前往登录并重置'}
        </button>

        <p className="mt-6 text-center text-sm text-slate-500">
          <Link to="/login" className="font-medium text-[#1f4fd8] hover:underline">
            返回登录
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
